import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
	change
} from "redux-form";

import {
	Icon
} from "rhombus-react";

import { useModalStack } from "utils/common";
import { EDIT_SOCIAL_VERSION_2 } from "forms/list";

import { getModalProps } from 'widgets/modals/versions/Helpers';
import SelectAssets from "widgets/modals/assets/SelectAssets";

import { ImageEditor, VideoEditor, TextEditor } from "./Editors";


export default function VariableRow(props){
	let editor = null
		, { creativeFields, mapping, ...restProps } = props
		, commonModalProps = getModalProps({ assetType:props.type, closeModal })
		, [, { pushModal, clearStack }, ModalStackHead] = useModalStack({ commonModalProps })
		, dispatch = useDispatch()
		, {
			searchTerm,
			selectedTypes,
		} = useSelector(state => state.versionDetails)
		, hideClass = ""
		;

	function closeModal(){
		clearStack();
	}

	function selectFromModal([assetId], assets){
		let selectedAsset = assets.find(asset => asset.id === assetId);
		if(!selectedAsset){
			// This generally shouldn't happen because we flush selections when the Asset items change
			console.error("Could not update asset selection.  Asset not found.");
			return;
		}

		dispatch(change(EDIT_SOCIAL_VERSION_2, props.name, {
			...props,
			data:selectedAsset.name,
			assetId:selectedAsset.id,
			prop:selectedAsset.url,
			fileSize:selectedAsset.filesize,
		}));
	}

	function openSelectionModal(){
		function Configured(props2){
			return (
				<SelectAssets
					{...props2}
					type = {props.type.toLowerCase()}
					allowEncodedVideo = {false}

					onSelect = {selectFromModal}
				/>
			);
		}
		pushModal(Configured);
	}

	if(/image/i.test(props.type)){
		editor = <ImageEditor {...restProps} openAssetModal={openSelectionModal} />;
	}
	if(/video/i.test(props.type)){
		editor = <VideoEditor {...restProps} openAssetModal={openSelectionModal} />;
	}
	if(/text/i.test(props.type)){
		editor = <TextEditor {...restProps} openAssetModal={openSelectionModal} extra={creativeFields?.[mapping?.creativeField]} />;
	}

	if(selectedTypes.length){
		if(!selectedTypes.includes(props.type)){
			hideClass = "is-hidden";
		}
	}

	if(searchTerm){
		let reg = new RegExp(searchTerm, "i")
			, fieldName = mapping?.creativeField
			, field = creativeFields?.[fieldName]
			, matchList = [
				restProps.name,
				restProps?.data,
				field?.label,
				field?.name,
				mapping?.name,
			].some(text => reg.test(text || ""))
			;

		if(!matchList){
			hideClass = "is-hidden";
		}
	}

	return (
		<div className={`variable-row ${hideClass}`}>
			{ModalStackHead && <ModalStackHead />}
			<Icon name={`asset${props.type}`} className="asset-icon" />
			{editor}
		</div>
	);
}
